import React, { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon } from 'lucide-react';
import { Logo } from './Logo';
const navItems = [{
  label: 'Home',
  to: '/'
}, {
  label: 'About Us',
  to: '/about'
}, {
  label: 'What We Offer',
  to: '/what-we-offer'
}, {
  label: 'Contact',
  to: '/contact'
}];
export function Header() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);
  return <header className="sticky top-0 z-50 w-full bg-white/95 shadow-[0_1px_0_0_rgba(43,58,85,0.08)] backdrop-blur" data-id="element-47" data-mp="2wjxkvi8yo6xg">
      <div aria-hidden="true" className="h-1 w-full bg-gradient-to-r from-brand-cyan via-brand-indigo to-brand-violet" data-id="element-48" data-mp="31cgw48k6epz3" />
      <div className="mx-auto flex h-24 max-w-content items-center justify-between px-6" data-id="element-49" data-mp="3baekqx5y6os8">
        <Logo data-id="element-50" data-mp="3fbq3qjubgbrg" />

        <nav aria-label="Main" className="hidden items-center gap-9 md:flex" data-id="element-51" data-mp="3fb88nqje43l4">
          {navItems.map(item => <NavLink key={item.to} to={item.to} end={item.to === '/'} className={({
          isActive
        }) => `relative py-1 text-sm font-medium transition-colors ${isActive ? 'text-brand-indigo' : 'text-navy-600 hover:text-brand-indigo'}`} data-id="element-52" data-mp="2wlvzt53f6hr6">
              {({
            isActive
          }) => <>
                  {item.label}
                  <span aria-hidden="true" className={`absolute -bottom-1 left-0 h-0.5 w-full rounded-full bg-gradient-to-r from-brand-cyan to-brand-violet transition-opacity ${isActive ? 'opacity-100' : 'opacity-0'}`} data-id="element-53" data-mp="3abzixn705vce" />
                </>}
            </NavLink>)}
        </nav>

        <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-controls="mobile-nav" aria-label={open ? 'Close menu' : 'Open menu'} className="rounded-md p-2 text-brand-indigo transition-colors hover:bg-brand-indigo/10 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-indigo md:hidden" data-id="element-54" data-mp="3ta2b2auuk8ef">
          {open ? <XIcon className="h-6 w-6" data-id="element-55" data-mp="1mla31c0i7s5w" /> : <MenuIcon className="h-6 w-6" data-id="element-56" data-mp="18mk4dry1dkff" />}
        </button>
      </div>

      {open && <div id="mobile-nav" className="border-t border-navy-100 bg-white md:hidden" data-id="element-57" data-mp="1cp6spivi0n7v">
          <nav aria-label="Mobile" className="mx-auto max-w-content px-6 py-2" data-id="element-58" data-mp="ypxkp6hg4zez">
            <ul className="flex flex-col" data-id="element-59" data-mp="13ngzc7i23e7g">
              {navItems.map(item => <li key={item.to} data-id="element-60" data-mp="2t36ochnb9qpb">
                  <NavLink to={item.to} end={item.to === '/'} className={({
              isActive
            }) => `block border-b border-navy-50 py-3.5 text-base font-medium ${isActive ? 'border-l-2 border-l-brand-violet pl-3 text-brand-indigo' : 'text-navy-700'}`} data-id="element-61" data-mp="2t48api9s1zmc">
                    {item.label}
                  </NavLink>
                </li>)}
            </ul>
          </nav>
        </div>}
    </header>;
}